import { IconProps } from '../icon-props-interface';
import '../icons.scss';

export const IconVariablesAndEvents = ({ color = 'var(--color-accent-1)' }: IconProps): JSX.Element => (
  <div className="icon-block">
    <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.9186 1.39403C11.103 0.965908 10.9655 0.465908 10.5873 0.190908C10.2092 -0.0840923 9.69358 -0.0590923 9.34045 0.247158L1.34046 7.24716C1.02796 7.52216 0.915456 7.96278 1.06233 8.35028C1.20921 8.73778 1.58421 9.00028 1.99983 9.00028H5.4842L3.08108 14.6065C2.89671 15.0347 3.0342 15.5347 3.41233 15.8097C3.79045 16.0847 4.30608 16.0597 4.6592 15.7534L12.6592 8.75341C12.9717 8.47841 13.0842 8.03778 12.9373 7.65028C12.7905 7.26278 12.4186 7.00341 11.9998 7.00341H8.51545L10.9186 1.39403Z" fill={color} />
    </svg>
  </div>
);

export default IconVariablesAndEvents;
